
import { showNotification } from 'Store/Notification/Notification.action';
import { fetchMutation } from 'Util/Request';
import  CartGiftCardQuery  from "../../query/CartGiftCard.query";
import CartDispatcher from "Store/Cart/Cart.dispatcher";
import { isSignedIn } from 'Util/Auth';


/** @namespace Store/CartGiftCardDispatcher */
export class CartGiftCardDispatcher{

    applyGiftCardToCart(dispatch, code, quoteId) {
            return fetchMutation(CartGiftCardQuery.getGiftCardApplyMutation(
                code, !isSignedIn() && quoteId
            )).then(
                /** @namespace Store/CartGiftCard/Dispatcher/applyGiftCardToCartFetchMutationThen */
                ({giftCardCodeApply: giftCardCodeApply}) => {
                CartDispatcher.updateInitialCartData(dispatch);
                dispatch(showNotification('success', __('GiftCard code is applied!')));
                },
                /** @namespace Store/CartGiftCard/Dispatcher/applyGiftCardToCartFetchMutationError */
                (errors) => dispatch(showNotification('error', errors[0].message ))
      )
    }
    removeGiftCardFromCart(dispatch, code, quoteId){
        return fetchMutation(
            CartGiftCardQuery.getGiftCardRemoveMutation(
                code, !isSignedIn() && quoteId
            )).then(
            /** @namespace Store/CartGiftCard/Dispatcher/removeGiftCardToCartFetchMutationThen */
            ({giftCardCodeRemove: giftCardCodeRemove}) => {
                CartDispatcher.updateInitialCartData(dispatch);
                dispatch(showNotification('success', __('GiftCard code is removed!')));
            },
            /** @namespace Store/CartGiftCard/Dispatcher/removeGiftCardToCartFetchMutationError */
            (errors) => dispatch(showNotification('error', errors[0].message ))
        )
    }

}

export default new CartGiftCardDispatcher()
